<div class="rtl flex flex-column align-items-center text-center gap-4 mt-8">
    <div class="flex flex-column gap-1 line-height-3 w-7">
        <div class="title2 fs-xxlarge"> עולם של פתרונות סליקה</div>
        <div class="fs-large">
            יותר מ-20 שנה אנחנו מובילים את מערך הגביה לאלפי ארגונים ועסקים בישראל
        </div>
    </div>
    <div class="flex flex-column gap-4">
        <div class="fs-xlarge font-bold">!אתר הניהול שלכם- הכל מתחיל כאן </div>

        <div class="flex flex-wrap gap-4 justify-content-center w-8 align-self-center fs-small font-semibold">
            <div class="white-square flex flex-column align-items-center">
                <img src="/assets/images/tracking.png">
                <span>מעקב אונליין אחר ביצוע עסקאות סטטוס ודוחות ליצוא</span>
            </div>
            <div class="lightblue-square flex flex-column align-items-center">
                <img src="/assets/images/creditCollection.png">
                <span>מגוון אופציות לגביה באשראי, בביט ובהו"ק בנקאיות </span>
            </div>

            <div class="lightblue-square  flex flex-column align-items-center">
                <img src="/assets/images/salesManagement.png">
                <span>ניהול מכירות ברשת </span>
                <span>הקמת קמפיין לגיוס המונים</span>
            </div>
            <div class="white-square flex flex-column align-items-center">
                <img src="/assets/images/EditingProjects.png">
                <span>עריכת פרויקטים דפי תשלום וטפסים דיגטליים</span>
            </div>
        </div>
    </div>
</div>